import Form from 'antd/lib/form';

export default Form;
